import { render, staticRenderFns } from "./ModalBanHC.vue?vue&type=template&id=1ec01d60"
import script from "./ModalBanHC.vue?vue&type=script&lang=js"
export * from "./ModalBanHC.vue?vue&type=script&lang=js"
import style0 from "./ModalBanHC.vue?vue&type=style&index=0&id=1ec01d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports